<template>
    <div id="baby-ticket-form">
        <div class="title">审核管理 > 亲子票务管理 > <span class="title-detail" @click="$router.go(-1)"> {{ title }}</span></div>
        <el-card class="main">
            <el-form 
                v-loading="formLoading"
                :model="ruleForm"
                :rules="rules"
                ref="ruleForm"
                status-icon
                label-width="200px"
                class="demo-ruleForm scorll-auto"
            >
                <div class="subtitle">
                    <h4>店铺信息</h4>
                </div>
                <el-form-item label="景区名称：" prop="name">
                    <el-input 
                        v-model="ruleForm.name"
                        maxlength="200"
                        placeholder="请输入景区名称"
                        show-word-limit
                        style="width:400px;"
                    >
                    </el-input>
                </el-form-item>
                <el-form-item label="店铺名称：" prop="shop_id">
                    <el-select 
                        v-model="ruleForm.shop_id"
                        filterable
                        placeholder="请选择店铺名称"
                        style="width: 400px"
                    >
                        <el-option 
                            v-for="item in shop_opt"
                            :key="item.shop_id"
                            :label="item.name"
                            :value="item.shop_id"
                        > 
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="景区星级：" prop="start">
                    <el-select 
                        v-model="ruleForm.start"
                        filterable
                        placeholder="请选择景区星级"
                        style="width: 400px"
                    >
                        <el-option 
                            v-for="item in startList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                <!-- 暂未添加字段，表单验证、表单详情需要同步更改 -->
                <el-form-item label="景区类型：" prop="scenic_spot">
                    <el-select 
                        v-model="ruleForm.scenic_spot"
                        filterable
                        placeholder="请选择景区类型"
                        style="width: 400px"
                    >
                        <el-option 
                            v-for="item in typeList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="景区介绍：" prop="desc">
                    <mavon-editor style="width:1000px;" placeholder="请填写" v-model="ruleForm.desc" ref="md1"/>
                </el-form-item>
                <el-form-item label="景区封面：" prop="image">
                    <el-upload 
                        style="display: inline-block"
                        action="https://jsonplaceholder.typicode.com/posts/"
                        :file-list="ruleForm.image"
                        list-type="picture-card"
                        :on-change="handleChange1"
                        :auto-upload="false"
                        :on-preview="handlePictureCardPreview"
                        :on-remove="handleRemove1"
                        :limit="1"
                        :class="ruleForm.image_detail.length == 1 ? 'mf' : ''"
                    >
                        <i class="el-icon-plus"></i>
                    </el-upload>
                </el-form-item>
                <el-form-item>
                    <el-link 
                        type="info" 
                        :underline="false"
                    >
                        支持文件格式: jpg, png, bmp, 单个文件不能超过5mb, 最多1张, 建议800*800像素
                    </el-link>
                </el-form-item>
                <el-form-item label="轮播图：" prop="banner">
                    <el-upload 
                        style="display: inline-block"
                        action="https://jsonplaceholder.typicode.com/posts/"
                        :file-list="ruleForm.banner"
                        list-type="picture-card"
                        :on-change="handleChange2"
                        :auto-upload="false"
                        :multiple="true"
                        :on-preview="handlePictureCardPreview"
                        :on-remove="handleRemove2"
                        :limit="8"
                        :class="ruleForm.banner_detail.length == 8 ? 'mf' : ''"
                    >
                        <i class="el-icon-plus"></i>
                    </el-upload>
                </el-form-item>
                <el-form-item>
                    <el-link 
                        type="info" 
                        :underline="false"
                    >
                        支持文件格式: jpg, png, bmp, 单个文件不能超过5mb, 最多8张, 建议800*800像素
                    </el-link>
                </el-form-item>
                <el-form-item label="景区地址：" prop="addr_s">
                    <el-form-item style="display: inline-block;">
                        <el-cascader
                            v-if="loadTemplate"
                            v-model="gdjzdSelectedOptions"
                            style="width: 400px"
                            placeholder="请选择"
                            :props="defaultProps"
                            :options="provincescitiesoptions"
                            filterable
                            @change="handleChange"
                        >
                        </el-cascader>
                    </el-form-item>
                    <el-form-item prop="addr_i" style="display: inline-block; margin-left: 12px;">
                         <el-input 
                            v-model="ruleForm.addr_i"
                            placeholder="请填写详细地址，例: 1层101"
                            style="width:400px;"
                        >
                        </el-input>
                    </el-form-item>
                </el-form-item>
                <el-form-item label="预约日历：" prop="calendar_id">
                    <el-select 
                        v-model="ruleForm.calendar_id"
                        filterable
                        placeholder="请选择地址"
                        style="width: 400px"
                    >
                        <el-option 
                            v-for="item in dateList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="开园时间：" prop="time">
                    <el-time-picker
                        is-range
                        v-model="ruleForm.time"
                        range-separator="至"
                        start-placeholder="开始时间"
                        end-placeholder="结束时间"
                        style="width:400px;"
                        placeholder="选择时间范围"
                    >
                    </el-time-picker>
                </el-form-item>
                <el-form-item label="购买须知：" prop="desc_buy">
                    <mavon-editor style="width:1000px;" placeholder="请输入游客须知" v-model="ruleForm.desc_buy" ref="md2"/>
                </el-form-item>
                <el-form-item label="景区福利：" prop="desc_welfare">
                    <mavon-editor style="width:1000px;" placeholder="请输入景区福利" v-model="ruleForm.desc_welfare" ref="md3"/>
                </el-form-item>
                <div class="subtitle">
                    <h4>规格属性</h4>
                </div>
                <div v-for="(item, index) in ruleForm.sku_list" :key="index">
                    <template v-if="item.is_delete == 0">
                        <el-form-item label="门票名称：">
                            <el-input 
                                v-model="item.name"
                                maxlength="20"
                                placeholder="请输入门票名称"
                                show-word-limit
                                style="width:400px;"
                            >
                            </el-input>
                            <i 
                                v-if="index== 0" 
                                class="el-icon-circle-plus-outline" 
                                @click="addAttribute" 
                                style="font-size: 26px; margin-left: 5px; color: #409EFF; position: absolute; top: 50%; transform: translateY(-50%); cursor: pointer;"
                            ></i>
                            <i 
                                v-else 
                                class="el-icon-remove-outline" 
                                @click="lessenAttribute(index, item)" 
                                style="font-size: 26px; margin-left: 5px; color: #F56C6C; position: absolute; top: 50%; transform: translateY(-50%); cursor: pointer;"
                            ></i>
                        </el-form-item>
                        <el-form-item label="门票价格：">
                            <el-input-number 
                                class="menpiao-price"
                                v-model="item.price"
                                placeholder="请输入门票价格"
                                style="width:400px;"
                                :precision="2"
                                controls-position="right"
                                :controls="false"
                                :min="1"
                            >
                            </el-input-number>
                        </el-form-item>
                        <el-form-item label="有效期：">
                            <el-select 
                                v-model="item.u_times"
                                filterable
                                placeholder="请选择"
                                style="width: 400px"
                            >
                                <el-option 
                                    v-for="date in indateList"
                                    :key="date.id"
                                    :label="date.label"
                                    :value="date.id"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="使用时段：">
                            <el-radio-group v-model="item.u_type">
                                <el-radio :label="1">平日</el-radio>
                                <el-radio :label="2">节假日</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="预订须知：">
                            <mavon-editor style="width:1000px;" placeholder="请输入预订须知" v-model="item.desc" :ref="'md'+index+4"/>
                        </el-form-item>
                        <el-form-item label="项目包含：">
                            <mavon-editor style="width:1000px;" placeholder="请输入项目包含" v-model="item.desc_buy" :ref="'md'+index+5"/>
                        </el-form-item>
                    </template>
                </div>
                <div class="subtitle">
                    <h4>交付方式</h4>
                </div>
                <el-form-item label="交付方式：" prop="g_type">
                    <el-checkbox-group v-model="ruleForm.g_type">
                        <el-checkbox :label="1">短信、app、站内信</el-checkbox>
                        <el-checkbox :label="2">物流</el-checkbox>
                        <el-checkbox :label="3">自提</el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
                <el-divider></el-divider>
                <el-form-item label-width="0" style="float: right;">
                    <el-button @click="$router.go(-1)">取消</el-button>
                    <el-button type="primary" @click="createArea" v-loading="btnLoading" :disabled="saveBtnStatus">{{btnLoading ? '正在保存' : '保存'}}</el-button>
                </el-form-item>
            </el-form>
        </el-card>
        <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="" />
        </el-dialog>
    </div>
</template>

<script>
import { getDateList, getDartList, getCityList, setArea, getAreaDetail, getAreaType } from '@/api/baby/ticket.js'
import { mapActions } from 'vuex';
import { getShopStorage } from '@/utils/storage.js'

export default {
    data () {
        return {
            operate: '',
            formLoading: false, // 表单loading
            btnLoading: false,  // 提交按钮loading
            saveBtnStatus: false,
            loadTemplate: true,
            ruleForm: {
                id: 0,          // 景区ID
                shop_id: '',     // 店铺ID
                name: '',       // 景区名称 2~200个字符
                start: 1,       // 景区星级 1~5星，对应A~5A
                scenic_spot: '',// 景区类型
                desc: '',       // 景区介绍
                desc_buy: '',   // 购买须知
                desc_welfare: '',// 景区福利
                appo: 1,        // 预约类型 1-平日 2-节假日
                g_type: [1],      // 交付方式 1-APP、短信、站内信 2-物流 3自提
                calendar_id: null, // 日历ID 最小值为0
                image: [],      // 景区封面图 200个字符以内
                banner: [],     // 景区轮播图 json形式的图片地址列表，默认 []
                addr_s: '',     // 省市区，空格拼接 200个字符以内
                addr_i: '',     // 详细地址 200个字符以内
                time_s: '09:00',     // 开园时间 hh:mm[:ss] 格式 默认值: 09:00
                time_e: '18:00',     // 闭园时间 hh:mm[:ss] 格式 默认值: 18:00
                time: [new Date(2022,1,1,9,0), new Date(2022,1,1,18,0)],
                time_end: '17:00',   // 停止进场时间 hh:mm[:ss] 格式 默认值: 17:00
                sku_list: [     // 景区门票列表，默认 []
                    {
                        id: 0,          // 门票ID，若添加则此处为0或不传此值
                        is_delete: 0,   // 是否删除操作 0-否 1-是
                        name: '',       // 门票名称
                        price: '',      // 门票价格
                        u_times: 30,    // 有效期 单位：天
                        u_type: 1,      // 使用类型 1-平日 2-节假日
                        tag_list: [],   // 选中标签列表，json形式列表
                        desc: '',       // 预定须知
                        desc_buy: ''    // 项目包含
                    }
                ],   
                image_detail: [],   // 封面图url
                banner_detail: [],  // 轮播图url

            },
            startList: [        // 星级
                { id: 1, name: '一星' },
                { id: 2, name: '二星' },
                { id: 3, name: '三星' },
                { id: 4, name: '四星' },
                { id: 5, name: '五星' }
            ],       
            addressList: [],    // 省级地址
            cityList: [],       // 市级地址
            dateList: [],       // 预约日历
            typeList: [],       // 景区类型
            shop_opt: [],       // 店铺列表
            indateList: [       // 有效期
                {
                    id: 30,
                    label: '30天'
                },
                {
                    id: 45,
                    label: '45天'
                },
                {
                    id: 60,
                    label: '60天'
                },
                {
                    id: 75,
                    label: '75天'
                },
                {
                    id: 90,
                    label: '90天'
                },
                {
                    id: 365,
                    label: '365天'
                },
            ],     
            rules: {
                name: [ 
                    { required: true, message: '请输入景区名称', trigger: 'blur' },
                    { max: 100, min: 2, message: '输入长度限制为2-100个', trigger: 'blur' } 
                ],
                start: [{ required: true, message: '请选择景区星级', trigger: 'change' }],
                shop_id: [{ required: true, message: '请选择店铺', trigger: 'change' }],
                scenic_spot: [
                    { required: true, message: '请选择景区类型', trigger: 'change' },
                ],
                desc: [
                    { required: true, message: '请输入景区介绍', trigger: 'blur' },
                    { max: 500, message: '输入长度限制为500个', trigger: 'blur' }
                ],
                image: [{ required: true, message: '请选择景区封面', trigger: 'change' }],
                banner: [{ required: true, message: '请选择轮播图', trigger: 'change' }],
                time: [ { required: true, message: '请选择开园时间', trigger: 'change' } ],
                calendar_id: [ { required: true, message: '请选择日历', trigger: 'change' } ],
                addr_s: [ { required: true, message: '请选择景区地址', trigger: 'change' } ],
                g_type: [ { required: true, message: '请选择交付方式', trigger: 'change' } ],
                addr_i: [
                    { required: true, message: '请输入详细地址', trigger: 'blur' },
                    { max: 100, message: '最大输入长度限制为100个字', trigger: 'blur' }
                ],
                desc_buy: [
                    { max: 500, message: '最大输入长度限制为500个字', trigger: 'blur' }
                ],
                desc_welfare: [
                    { max: 500, message: '最大输入长度限制为500个字', trigger: 'blur' }
                ]
            },
            dialogImageUrl: '',
            dialogVisible: false,
            standardAttirbute: [
                { name: '', price: '',  indate: '', appo: 1, notice: '', comprise: '' }
            ],
            provincescitiesoptions: [],
            defaultProps: {
                label: "regionName",
                value: "regionName",
                children: "children",
                lazy: true,
                lazyLoad: this.lazyLoad,
            },
            // 固定居住地选择器绑定的数据
            gdjzdSelectedOptions: [],
            sku_list: [
                {
                    id: 0,          // 门票ID，若添加则此处为0或不传此值
                    is_delete: 0,   // 是否删除操作 0-否 1-是
                    name: '',       // 门票名称
                    price: '',      // 门票价格
                    u_times: 30,    // 有效期 单位：天
                    u_type: 1,      // 使用类型 1-平日 2-节假日
                    tag_list: [],   // 选中标签列表，json形式列表
                    desc: '',       // 预定须知
                    desc_buy: ''    // 项目包含
                }
            ]
        }
    },
    computed: {
        title () {
            switch (this.operate) {
                case 'add':
                    return '新增亲子票务';
                case 'update':
                    return '编辑亲子票务';
            }
        }
    },
    methods: {
        ...mapActions({
            uploadFile: "commodity/uploadFile",
            getshopIdName: "newshop/getshopIdName"
        }),
        createArea () {
            // 交付方式  复选框二进制 101 1表示选中0表示未选中
            let g_type = [
                { name: 1, value: 0 },
                { name: 2, value: 0 },
                { name: 3, value: 0 }
            ];
            
            this.ruleForm.g_type.forEach(g_ => {
                let index = g_type.findIndex(g => {
                    return g.name == g_
                })
                if (index > -1) {
                    g_type[index].value = 1
                }
            })

            let sku_list =  this.ruleForm.sku_list.map(item => {
                return {...item, tag_list: JSON.stringify(item.tag_list)}
            })

            let name_list = []

            for(let i = 0; i < sku_list.length; i++) {
                name_list.push(sku_list[i].name)
            }

            const containsAllUnique = (arr = []) => {
                const { length: l } = arr;
                for(let i = 0; i < l; i++){
                    const el = arr[i];
                    const firstIndex = arr.indexOf(el);
                    const lastIndex = arr.lastIndexOf(el);
                    if(firstIndex !== lastIndex){
                        return false;
                    };
                };
                return true;
            };


            this.btnLoading = true;
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    if (!this.ruleForm.image_detail.length) {
                        this.$message.error('请选择景区封面！')
                        this.btnLoading = false;
                        return 
                    }
                    if (!this.ruleForm.banner_detail.length) {
                        this.$message.error('请选择轮播图！')
                        this.btnLoading = false;
                        return 
                    }
                    let list = [...this.ruleForm.sku_list];
                    for(let sku = 0; sku < list.length; sku++) {
                        if (list[sku].is_delete == 0) {
                            if (!list[sku].name) {
                                this.$message.error('门票名称不能为空！')
                                this.btnLoading = false;
                                return
                            }
                            if (list[sku].name && list[sku].name.length > 100) {
                                this.$message.error('门票名称最大输入长度为100个字')
                                this.btnLoading = false;
                                return
                            }
                            if (!list[sku].price) {
                                this.$message.error('门票价格不能为空！')
                                this.btnLoading = false;
                                return
                            }
                            if (!list[sku].u_times) {
                                this.$message.error('请选择有效期！')
                                this.btnLoading = false;
                                return
                            }
                            if (list[sku].desc && list[sku].desc.length > 500) {
                                this.$message.error('预定须知最大输入长度为500个字')
                                this.btnLoading = false;
                                return
                            }
                            if (list[sku].desc && list[sku].desc_buy.length > 500) {
                                this.$message.error('项目包含最大输入长度为500个字')
                                this.btnLoading = false;
                                return
                            }
                        }
                    }

                    if (!containsAllUnique(name_list)) {
                        this.$message.error('门票名称不能重复')
                        this.btnLoading = false;
                        return
                    }
                    let data = {
                        id: this.ruleForm.id,
                        shop_id: this.ruleForm.shop_id,
                        name: this.ruleForm.name,
                        start: this.ruleForm.start,
                        scenic_spot: this.ruleForm.scenic_spot + '',
                        desc: this.ruleForm.desc,
                        desc_buy: this.ruleForm.desc_buy,
                        desc_welfare: this.ruleForm.desc_welfare,
                        appo: this.ruleForm.appo,
                        g_type: g_type.map(item => { return item.value }).join(''),
                        calendar_id: this.ruleForm.calendar_id,
                        image: this.ruleForm.image_detail[0].url,
                        banner: JSON.stringify(this.ruleForm.banner_detail.map(item => item.url)),
                        addr_s: this.gdjzdSelectedOptions.join(),
                        addr_i: this.ruleForm.addr_i,
                        time_s: this.buling(this.ruleForm.time[0].getHours()) + ':' + this.buling(this.ruleForm.time[0].getMinutes()),
                        time_e: this.buling(this.ruleForm.time[1].getHours()) + ':' + this.buling(this.ruleForm.time[1].getMinutes()),
                        time_end: this.ruleForm.time_end,
                        sku_list: JSON.stringify(this.ruleForm.sku_list.map(item => {
                            return {...item, tag_list: JSON.stringify(item.tag_list)}
                        }))
                    }
                    setArea(data)
                        .then(res => {
                            if (res.data.code == 0) {
                                this.$message.success(data.id == 0 ?' 添加成功！' : '编辑成功！')
                                this.$router.go(-1);
                            } else {
                                this.$message.error(res.data.msg);
                            }
                        })
                        .catch(err => {
                            this.$message.error(err.msg)
                        })
                        .finally(_ => {
                            this.btnLoading = false;
                        })
                } else {
                    this.btnLoading = false;
                    return
                }
            })
        },
        handleChange (value) {
            this.ruleForm.addr_s = value;
            this.gdjzdSelectedOptions = value;
        },
        lazyLoad (node, resolve) {
            this.initAddress(node, resolve);
        },
        addAttribute () {
            this.ruleForm.sku_list.push(
                {
                    id: 0,          // 门票ID，若添加则此处为0或不传此值
                    is_delete: 0,   // 是否删除操作 0-否 1-是
                    name: '',       // 门票名称
                    price: '',      // 门票价格
                    u_times: 30,    // 有效期 单位：天
                    u_type: 1,      // 使用类型 1-平日 2-节假日
                    tag_list: [],   // 选中标签列表，json形式列表
                    desc: '',       // 预定须知
                    desc_buy: ''    // 项目包含
                }
            );
        },
        lessenAttribute (index, item) {
            if (item.id == 0) {
                this.ruleForm.sku_list.splice(index,1);
            } else {
                this.ruleForm.sku_list[index].is_delete = 1;
            }
        },
        handleChange1 (file, fileList) {
            var formdata = new FormData();
            formdata.append("formdata", file.raw);
            this.ruleForm.image = fileList;
            this.uploadFile(formdata).then((res) => {
                if (res.code == 1) {
                    this.$message.success("上传成功！");
                    this.ruleForm.image_detail.push({
                        file: file,
                        url: res.data.formdata_details[0].urls,
                    })
                } else {
                    this.$message({
                        type: "warning",
                        message: res.msg,
                    });
                }
            });
        },
        handleRemove1 (file, fileList) {
            this.ruleForm.image_detail = this.ruleForm.image_detail.filter((item) => {
                return item != file;
            });
        },
        handleChange2 (file, fileList) {
            var formdata = new FormData();
            formdata.append("formdata", file.raw);
            this.ruleForm.banner = fileList;
            this.uploadFile(formdata).then((res) => {
                if (res.code == 1) {
                    this.$message.success("上传成功！");
                    this.ruleForm.banner_detail.push({
                        file: file,
                        url: res.data.formdata_details[0].urls,
                    });
                } else {
                    this.$message({
                        type: "warning",
                        message: res.msg,
                    });
                }
            });
        },
        handleRemove2 (file, fileList) {
            this.ruleForm.banner_detail = this.ruleForm.banner_detail.filter((item) => {
                if (item.file == "1") {
                    return item.url != file.url;
                } else return item.file != file;
            });
        },
        handlePictureCardPreview (file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        buling (num) {
            return num > 9 ? num : '0' + num
        },
        initDateList () {
            getDateList()
                .then(res => {
                    if (res.data.code == 0) {
                        this.dateList = res.data.data.data;
                        let index = this.dateList.findIndex(date => { return date.is_default == 1 });
                        this.ruleForm.calendar_id = this.dateList[index].id
                    }
                })
                .catch(err => {
                    this.$message.error()
                })
        },
        initAddress (node, resolve) {
            if (!node.data) {
                getDartList()
                    .then(res => {
                        if (res.data.code == 0) {
                            this.addressList = res.data.data;
                            const nodes = this.addressList.map(item => {
                                return {
                                    regionName: item.regionName,
                                    regionId: item.regionId,
                                    parentId: item.parentId
                                }
                            })
                            resolve(nodes)
                        } else {
                            this.$message.error(res.data.message);
                        }
                    })
                    .catch(err => {
                        this.$message.error(err.message)
                    })
            } else {
                let parentId = node.data.regionId;
                getCityList({parentId})
                    .then(res => {
                        if (res.data.code == 0) {
                            this.cityList = res.data.data;
                            const nodes = this.cityList.map(item => {
                                return {
                                    regionName: item.regionName,
                                    regionId: item.regionId,
                                    parentId: item.parentId,
                                    leaf: node.level >= 2
                                }
                            })
                            resolve(nodes)
                        } else {
                            this.$message.error(res.data.message);;
                        }
                    })
                    .catch(err => {
                        this.$message.error(err.message)
                    })
            }
        },
        getDetail () {
            this.formLoading = true;
            let data = {
                id: this.$route.query.id,
                shop_id: this.$route.query.shop_id
            }
            this.loadTemplate = false;
            getAreaDetail(data)
                .then(res => {
                    if (res.data.code == 0) {
                        this.saveBtnStatus = false;
                        let { data } = res.data
                        this.ruleForm.id = data.id;
                        this.ruleForm.shop_id = data.shop_id;
                        this.ruleForm.name = data.name;
                        this.ruleForm.start = data.start;
                        this.ruleForm.scenic_spot = data.scenic_spot*1,
                        this.ruleForm.desc = data.desc;
                        this.ruleForm.desc_buy	 = data.desc_buy	;
                        this.ruleForm.desc_welfare = data.desc_welfare;
                        this.ruleForm.appo = data.appo;
                        this.ruleForm.calendar_id = data.calendar_id;
                        this.ruleForm.image = data.image.split().map(img => {return{url: img}});
                        this.ruleForm.banner = JSON.parse(data.banner).map(img => {return{url: img}});
                        this.ruleForm.addr_s = data.addr_s.split(',');
                        this.ruleForm.addr_i = data.addr_i;
                        this.ruleForm.time_s = data.time_s;
                        this.ruleForm.time_e = data.time_e;
                        this.ruleForm.time_end = data.time_end;
                        this.ruleForm.sku_list = data.sku_list;
                        this.ruleForm.time = [new Date(2022,1,1,data.time_s.split(':')[0],data.time_s.split(':')[1]), new Date(2022,1,1,data.time_e.split(':')[0],data.time_e.split(':')[1])];
                        this.ruleForm.image_detail = data.image.split().map(img => {return{url: img}});
                        this.ruleForm.banner_detail = JSON.parse(data.banner).map(img => {return{url: img}});
                        this.gdjzdSelectedOptions = data.addr_s.split(',');
                        
                        // 交付方式
                        this.ruleForm.g_type.splice(0, this.ruleForm.g_type.length)
                        let g_type = [
                            { name: 1, value: 0 },
                            { name: 2, value: 0 },
                            { name: 3, value: 0 }
                        ];
                        data.g_type.split('').forEach((g, i) => {
                            g_type[i].value = g
                        })

                        g_type.forEach(g_ => {
                            if (g_.value == 1) {
                                this.ruleForm.g_type.push(g_.name)
                            }
                        })
                        this.loadTemplate = true;
                    } else {
                        this.saveBtnStatus = true;
                        this.$message.error(res.data.msg);
                    }
                })
                .catch(err => {
                    this.saveBtnStatus = true;
                    this.$message.error(err.msg);
                })
                .finally(_ => {
                    this.formLoading = false;
                })
        },
        areaTypeList () {
            let params = {
                platform: 13
            }
            getAreaType(params)
                .then(res => {
                    if (res.data.code == 0) {
                        this.typeList = res.data.data.data;
                    } else {
                        this.$message.error(res.data.code);
                    }
                })
                .catch(err => {
                    this.$message.error(err.msg);
                })
        }
    },
    mounted () {
        this.operate = this.$route.query.operate;
        window.scrollTo(0, 0);
        if (getShopStorage()) {
            this.shop_opt = getShopStorage();
        } else {
            this.$confirm('您还没有自己的店铺哦，快去申请店铺吧！','提示',{
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                callback: action => {
                    if (action == 'confirm') {
                        this.$router.push({ path: "/home/shopManage" });
                    }
                }
            });
        }
        if (this.$route.query.operate == 'update') {
            this.getDetail()
        }
        this.initDateList();
        this.areaTypeList();
    }
}
</script>

<style lang="scss" scoped>
    #baby-ticket-form {
        min-width: 1260px;
        .title {
            box-shadow: 0px 0px 8px 0px rgb(100 100 100 / 17%);
            width: 100%;
            background: #fff;
            padding: 15px 32px;
            display: flex;
            align-items: center;
            font-size: 18px;
            color: #000;
            font-weight: 600;
            .title-detail {
                margin-left: 5px;
                color: rgb(109, 109, 109);
                cursor: pointer;
            }
            p {
                font-size: 16px;
                color: #333;
                margin-left: 32px;

                span {
                    color: #e72f0d;
                    padding: 0 5px;
                }

                &:first-child {
                    font-size: 18px;
                    color: #333;
                    margin-left: 0;
                }

                &:nth-child(2) {
                    span {
                        color: #2448ff;
                    }
                }
            }
            .title-detail {
                cursor: pointer;
            }
        }
        .main {
            margin: 24px 24px 2px 24px;
            border-radius: 0;
            .subtitle {
                margin: 35px 0;
                display: flex;
                align-items: center;
                &:first-child {
                    margin-top: 0;
                }
                h4 {
                    padding-left: 20px;
                    line-height: 18px;
                    position: relative;
                    font-size: 16px;
                    font-weight: bold;
                    color: #333333;
                    &::before {
                    content: "";
                    position: absolute;
                    left: 0;
                    top: 0;
                    height: 100%;
                    width: 2px;
                    background: #2448ff;
                    }
                }
            }
        }
    }

    ::v-deep .el-card__body {
        padding-left: 60px;
        padding-top: 40px;
    }

    .mf {
        ::v-deep .el-upload--picture-card {
            display: none !important;
        }
    }

    ::v-deep .el-dialog__header {
        border-bottom: 1px solid #F1F1F1;
        font-weight: bold;
    }
    
    ::v-deep .el-dialog {
        border-radius: 10px;
        min-width: 580px;
    }

    ::v-deep .el-dialog__footer {
        border-top: 1px solid #F1F1F1;
        padding: 10px 20px 10px;
    }

    ::v-deep .el-dialog__body {
        padding: 60px 80px;
    }
    
    .menpiao-price ::-webkit-input-placeholder {
        text-align: left;
    }

    ::v-deep .el-input-number {
        .el-input__inner {
            text-align: left;
        }
    }
    

</style>